/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Push_Meeting_BodyInputs */

const th_push_meeting_body = /** @type {(inputs: Push_Meeting_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const en_push_meeting_body = /** @type {(inputs: Push_Meeting_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const ja_push_meeting_body = /** @type {(inputs: Push_Meeting_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const zh_push_meeting_body = /** @type {(inputs: Push_Meeting_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const es_push_meeting_body = /** @type {(inputs: Push_Meeting_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const pt_push_meeting_body = /** @type {(inputs: Push_Meeting_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const id_push_meeting_body = /** @type {(inputs: Push_Meeting_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const fr_push_meeting_body = /** @type {(inputs: Push_Meeting_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const tl_push_meeting_body = /** @type {(inputs: Push_Meeting_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const vi_push_meeting_body = /** @type {(inputs: Push_Meeting_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const ko_push_meeting_body = /** @type {(inputs: Push_Meeting_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const de_push_meeting_body = /** @type {(inputs: Push_Meeting_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const ru_push_meeting_body = /** @type {(inputs: Push_Meeting_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const tr_push_meeting_body = /** @type {(inputs: Push_Meeting_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const it_push_meeting_body = /** @type {(inputs: Push_Meeting_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const pl_push_meeting_body = /** @type {(inputs: Push_Meeting_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const uk_push_meeting_body = /** @type {(inputs: Push_Meeting_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const hi_push_meeting_body = /** @type {(inputs: Push_Meeting_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const ar_push_meeting_body = /** @type {(inputs: Push_Meeting_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const ms_push_meeting_body = /** @type {(inputs: Push_Meeting_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const bn_push_meeting_body = /** @type {(inputs: Push_Meeting_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const zh_tw2_push_meeting_body = /** @type {(inputs: Push_Meeting_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const zh_hk2_push_meeting_body = /** @type {(inputs: Push_Meeting_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const ur_push_meeting_body = /** @type {(inputs: Push_Meeting_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const fa_push_meeting_body = /** @type {(inputs: Push_Meeting_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const sw_push_meeting_body = /** @type {(inputs: Push_Meeting_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

const nl_push_meeting_body = /** @type {(inputs: Push_Meeting_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}`)
};

/**
* | output |
* | --- |
* | "{title}" |
*
* @param {Push_Meeting_BodyInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_meeting_body = /** @type {((inputs: Push_Meeting_BodyInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Meeting_BodyInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_push_meeting_body(inputs)
	if (locale === "ja") return ja_push_meeting_body(inputs)
	if (locale === "zh") return zh_push_meeting_body(inputs)
	if (locale === "es") return es_push_meeting_body(inputs)
	if (locale === "pt") return pt_push_meeting_body(inputs)
	if (locale === "id") return id_push_meeting_body(inputs)
	if (locale === "fr") return fr_push_meeting_body(inputs)
	if (locale === "tl") return tl_push_meeting_body(inputs)
	if (locale === "vi") return vi_push_meeting_body(inputs)
	if (locale === "ko") return ko_push_meeting_body(inputs)
	if (locale === "de") return de_push_meeting_body(inputs)
	if (locale === "ru") return ru_push_meeting_body(inputs)
	if (locale === "tr") return tr_push_meeting_body(inputs)
	if (locale === "it") return it_push_meeting_body(inputs)
	if (locale === "pl") return pl_push_meeting_body(inputs)
	if (locale === "uk") return uk_push_meeting_body(inputs)
	if (locale === "hi") return hi_push_meeting_body(inputs)
	if (locale === "ar") return ar_push_meeting_body(inputs)
	if (locale === "ms") return ms_push_meeting_body(inputs)
	if (locale === "bn") return bn_push_meeting_body(inputs)
	if (locale === "zh-TW") return zh_tw2_push_meeting_body(inputs)
	if (locale === "zh-HK") return zh_hk2_push_meeting_body(inputs)
	if (locale === "ur") return ur_push_meeting_body(inputs)
	if (locale === "fa") return fa_push_meeting_body(inputs)
	if (locale === "sw") return sw_push_meeting_body(inputs)
	if (locale === "nl") return nl_push_meeting_body(inputs)
	return en_push_meeting_body(inputs)
});